import { render, staticRenderFns } from "./utils-explainers-pop-edit.vue?vue&type=template&id=63efb012&scoped=true"
import script from "./utils-explainers-pop-edit.vue?vue&type=script&lang=js"
export * from "./utils-explainers-pop-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63efb012",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63efb012')) {
      api.createRecord('63efb012', component.options)
    } else {
      api.reload('63efb012', component.options)
    }
    module.hot.accept("./utils-explainers-pop-edit.vue?vue&type=template&id=63efb012&scoped=true", function () {
      api.rerender('63efb012', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/muiutils/views/explainers/utils-explainers-pop-edit.vue"
export default component.exports